import { render, staticRenderFns } from "./AICallLog.vue?vue&type=template&id=01e8c9db&"
import script from "./AICallLog.vue?vue&type=script&lang=js&"
export * from "./AICallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports